export default "__VITE_ASSET__DW9wPlhu__"